import * as React from 'react';
import './CardComponent.css';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import {Box, Button} from "@mui/material";
import {IconButton} from '@mui/material';
import {KeyboardArrowLeft} from "@mui/icons-material";
import {Link} from "react-router-dom";
import {slugify} from "../../Utils/url";


interface CardProps {
    imgPath: string;
    data: {
        id: number;
        name: string;
        office: string;
        end_date?: Date;
        industry?: string;
        description: string;
        finished_stages: number;
        late_stages: number;
        over_year_late_stages: number;
        in_progress_stages: number;
        not_started_stages: number;
        current_stage: any;
        days_late: any;
    };
    onToggle?: () => void;
}

export default function CardTextComponent({imgPath, data, onToggle}: CardProps) {
    return (

        <Card sx={{width: '100%', height: 550, backgroundColor: "#EEF1F7", borderRadius: '30px', position: 'relative'}}>
            <IconButton
                aria-expanded={true}
                aria-label={'חזרה'}
                sx={{
                    position: 'absolute',
                    top: 8,
                    left: 8,
                    backgroundColor: '#0C3768',
                    boxShadow: 1,
                    '&:hover': {
                        backgroundColor: '#f0f0f0',
                    },
                    padding: 1,
                    marginLeft: 2,
                    marginTop: 1.5,
                }}
                onClick={onToggle}

            >
                <img src="/images/backArrow.svg" alt="" width={10} height={10}/>
            </IconButton>
            <Box
                sx={{
                    position: 'absolute',
                    top: 8,
                    right: 8,
                    backgroundColor: '#EEF1F7',
                    boxShadow: 1,
                    padding: 0.5,
                    borderColor: '#0C3768',
                    borderStyle: 'solid',
                    borderWidth: '3px',
                    marginRight: 1.5,
                    marginTop: 1.5,
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: 12,
                    height: 12,
                }}
            >
                <img src="/images/i.svg" alt="" width={10} height={10}/>
            </Box>
            <CardContent sx={{height: '100%', boxSizing: 'border-box', display: 'flex', flexDirection: 'column', justifyContent: 'space-between'}}>
                <div>
                    <Typography gutterBottom variant="h6" component="div"
                                sx={{fontSize: '18px', color: '#0C3768', fontWeight: 'bold', textAlign: 'right', marginRight: '40px'}}>
                        <h3 style={{margin:0, padding:0}}>תיאור המיזם</h3>
                    </Typography>
                    <Typography variant="body1" sx={{color: '#0C3768', textAlign: 'right', mt: 3, maxHeight: '330px', overflowY: 'scroll'}}>
                        {data.description}
                    </Typography>
                </div>
                <div>
                    {data.days_late >= 365 &&
                    <Box sx={{display: 'flex', flexDirection: 'row', alignItems: 'center', my: 3}}>
                        <Box sx={{width: '20px', height: '20px', textAlign: 'center', borderRadius: '50%', color: '#0C3768', background: '#FE6F5C'}}>i</Box>
                        <Typography gutterBottom variant="h6" component="div"
                                    sx={{fontSize: '18px', color: '#0C3768', fontWeight: 'bold', textAlign: 'right', marginRight: '10px'}}>
                            יש עיכוב של {data.days_late} ימים
                        </Typography>
                    </Box>}
                    {data.days_late > 0 && data.days_late < 365 &&
                    <Box sx={{display: 'flex', flexDirection: 'row', alignItems: 'center', my: 3}}>
                        <Box sx={{width: '20px', height: '20px', textAlign: 'center', borderRadius: '50%', color: '#0C3768', background: '#FFBD06'}}>i</Box>
                        <Typography gutterBottom variant="h6" component="div"
                                    sx={{fontSize: '18px', color: '#0C3768', fontWeight: 'bold', textAlign: 'right', marginRight: '10px'}}>
                            יש עיכוב של {data.days_late} ימים
                        </Typography>
                    </Box>}
                    {data.days_late === 0 &&
                        <Box sx={{display: 'flex', flexDirection: 'row', alignItems: 'center', my: 3}}>
                            <Typography gutterBottom variant="h6" component="div"
                                        sx={{fontSize: '18px', color: '#0C3768', fontWeight: 'bold', textAlign: 'right', marginRight: '10px'}}>
                                 אין עיכוב במועד סיום המיזם
                            </Typography>
                        </Box>}
                    <Button
                        component={Link}
                        to={`/project-about/${data.id}/${slugify(data.name)}`}
                        variant="outlined"
                        fullWidth
                        endIcon={<KeyboardArrowLeft />}
                        sx={{
                            borderRadius: '1rem',
                            textTransform: 'none',
                            justifyContent: 'center',
                            gap: 1,
                            py: 1.5,
                            borderColor: '#0C3768',
                            color: '#0C3768',
                            backgroundColor: 'transparent',
                            width: '100%',
                            fontWeight: 700,
                        }}
                    >
                        לצפייה בלו"ז המיזם
                    </Button>
                </div>
            </CardContent>
        </Card>
    );
}